module.exports = __webpack_public_path__ + "img/sun.31153a8f.svg";